export default {
  OnFormSerialized: 'onFormSerialized',
  OnFormSuccess: 'onFormSucces'
}
